import { select, selection, event } from 'd3-selection';
import { transition } from 'd3-transition';
import { fonts, display } from '@redsift/d3-rs-theme';

var version = "0.10.0";

var DEFAULT_WIDTH = 800;
function tip(id) {
  var d3_tip_functor = function d3_tip_functor(v) {
    return typeof v === "function" ? v : function () {
      return v;
    };
  };
  var d3_tip_direction = function d3_tip_direction() {
    return 'n';
  };
  var d3_tip_offset = function d3_tip_offset() {
    return [0, 0];
  };
  var d3_tip_html = function d3_tip_html() {
    return ' ';
  };
  var IsDOMElement = function IsDOMElement(o) {
    return o instanceof Node;
  };
  transition();
  var direction = d3_tip_direction,
    offset = d3_tip_offset,
    html = d3_tip_html,
    classed = 'd3-tip',
    node = initNode(),
    point = null,
    target = null,
    parent = null,
    theme = 'light',
    transition$$1 = false,
    style = undefined,
    zIndex = 16777271;
  function initNode() {
    var node = select('div' + (id ? '#' + id : '.' + classed));
    if (node.empty()) node = select(document.createElement('div'));
    node.attr('id', id).attr('class', classed).style('position', 'absolute').style('top', 0).style('left', 0).style('opacity', 0).style('pointer-events', 'none').style('box-sizing', 'border-box');
    return node.node();
  }
  function getSVGNode(el) {
    el = el.node();
    if (!el) return;
    return el.tagName.toLowerCase() === 'svg' ? el : el.ownerSVGElement;
  }
  function getNodeEl() {
    if (node === null) {
      node = initNode();
      parent.appendChild(node);
    }
    return select(node);
  }
  function _impl(vis) {
    if (!parent) {
      document.body.appendChild(node);
    }
    var svg = getSVGNode(vis);
    if (!svg) return;
    if (svg.createSVGPoint != null) {
      point = svg.createSVGPoint();
    }
    svg = select(svg);
    var defsEl = svg.select('defs');
    if (defsEl.empty()) {
      defsEl = svg.append('defs');
    }
    var _style = style;
    if (_style === undefined) {
      _style = _impl.defaultStyle(theme, DEFAULT_WIDTH);
    }
    var styleEl = defsEl.selectAll('style' + (id ? '#style-tip-' + id : '.style-' + classed)).data(_style ? [_style] : []);
    styleEl.exit().remove();
    styleEl = styleEl.enter().append('style').attr('type', 'text/css').attr('id', id ? 'style-tip-' + id : null).attr('class', id ? null : 'style-' + classed).merge(styleEl);
    styleEl.text(function (s) {
      return s;
    });
  }
  _impl.self = function () {
    return 'div' + (id ? '#' + id : '.' + classed);
  };
  _impl.id = function () {
    return id;
  };
  _impl.classed = function (_) {
    return arguments.length ? (classed = _, _impl) : classed;
  };
  _impl.show = function () {
    if (!parent) _impl.parent(document.body);
    var args = [].slice.call(arguments);
    target = this;
    var standalone = false;
    if (args.length === 1 && IsDOMElement(args[0])) {
      target = args[0];
      args[0] = target.__data__;
      standalone = true;
    }
    var content = html.apply(target, args);
    if (content === null) return _impl;
    var poffset = offset.apply(target, args),
      dir = direction ? direction.apply(target, args) : null,
      nodel = getNodeEl(),
      i = directions.length,
      parentCoords = node.offsetParent.getBoundingClientRect();
    while (i--) nodel.classed(directions[i], false);
    if (content != null) {
      nodel.html(content);
    }
    if (dir) {
      nodel.classed(dir, true);
    } else {
      dir = 'n';
    }
    var coords = direction_callbacks[dir].apply(target);
    nodel.style('top', coords.top + poffset[0] - parentCoords.top + 'px').style('left', coords.left + poffset[1] - parentCoords.left + 'px').style('z-index', zIndex);
    if (standalone) {
      window.addEventListener('load', function () {
        coords = direction_callbacks[dir].apply(target);
        nodel.style('top', coords.top + poffset[0] - parentCoords.top + 'px').style('left', coords.left + poffset[1] - parentCoords.left + 'px');
      });
    }
    if (transition$$1 != null && transition$$1 !== false) {
      nodel = nodel.transition();
      if (typeof transition$$1 === 'number') {
        nodel = nodel.duration(transition$$1);
      }
    }
    nodel.style('opacity', 1.0);
    return _impl;
  };
  _impl.hide = function () {
    var nodel = getNodeEl();
    if (nodel.interrupt) {
      nodel.interrupt();
    }
    nodel.style('opacity', 0.0);
    return _impl;
  };
  _impl.attr = function (n) {
    if (arguments.length < 2 && typeof n === 'string') {
      return getNodeEl().attr(n);
    } else {
      var args = [].slice.call(arguments);
      selection.prototype.attr.apply(getNodeEl(), args);
    }
    return _impl;
  };
  _impl.direction = function (v) {
    if (!arguments.length) return direction;
    direction = v == null ? v : d3_tip_functor(v);
    return _impl;
  };
  _impl.offset = function (v) {
    if (!arguments.length) return offset;
    offset = v == null ? v : d3_tip_functor(v);
    return _impl;
  };
  _impl.html = function (v) {
    if (!arguments.length) return html;
    html = v == null ? v : d3_tip_functor(v);
    return _impl;
  };
  _impl.destroy = function () {
    if (node) {
      getNodeEl().remove();
      node = null;
    }
    return _impl;
  };
  _impl.style = function (_) {
    return arguments.length ? (style = _, _impl) : style;
  };
  _impl.transition = function (_) {
    return arguments.length ? (transition$$1 = _, _impl) : transition$$1;
  };
  _impl.theme = function (_) {
    return arguments.length ? (theme = _, _impl) : theme;
  };
  _impl.zIndex = function (_) {
    return arguments.length ? (zIndex = _, _impl) : zIndex;
  };
  _impl.parent = function (v) {
    if (!arguments.length) return parent;
    parent = v || document.body;
    parent.appendChild(node);
    var offsetParent = select(node.offsetParent);
    if (offsetParent.style('position') === 'static') {
      offsetParent.style('position', 'relative');
    }
    return _impl;
  };
  _impl.defaultStyle = function (_theme, _width) {
    return "\n                  ".concat(fonts.fixed.cssImport, "  \n                  ").concat(_impl.self(), " {\n                                    line-height: 1;\n                                    font-family: ").concat(fonts.fixed.family, ";\n                                    color: ").concat(display[_theme].negative.text, ";\n                                    font-weight: ").concat(fonts.fixed.weightMonochrome, ";  \n                                    font-size: ").concat(fonts.fixed.sizeForWidth(_width), ";  \n                                    padding: 8px;\n                                    background: ").concat(display[_theme].negative.background, ";\n                                    border-radius: 2px;\n                                    pointer-events: none;\n                                  }\n                    /* Creates a small triangle extender for the tooltip */\n                    ").concat(_impl.self(), ":after {\n                                      box-sizing: border-box;\n                                      display: inline;\n                                      width: 100%;\n                                      line-height: 1;\n                                      color: ").concat(display[_theme].negative.background, ";\n                                      font-size: ").concat(fonts.fixed.sizeForWidth(1), ";  \n                                      position: absolute;\n                                      pointer-events: none;\n                                    }\n                    /* Northward tooltips */\n                    ").concat(_impl.self(), ".n:after {\n                                      content: \"\\25bc\";\n                                      margin: -3px 0 0 0;\n                                      top: 100%;\n                                      left: 0;\n                                      text-align: center;\n                                    }\n                    /* Eastward tooltips */\n                    ").concat(_impl.self(), ".e:after {\n                                      content: \"\\25C0\";\n                                      margin: -7px 0 0 0;\n                                      top: 50%;\n                                      left: -7px;\n                                    }\n                    /* Southward tooltips */\n                    ").concat(_impl.self(), ".s:after {\n                                      content: \"\\25B2\";\n                                      margin: 0 0 1px 0;\n                                      top: -10px;\n                                      left: 0;\n                                      text-align: center;\n                                    }\n                    /* Westward tooltips */\n                    ").concat(_impl.self(), ".w:after {\n                                      content: \"\\25B6\";\n                                      margin: -7px 0 0 0;\n                                      top: 50%;\n                                      left: 100%;\n                                    }                \n                ");
  };
  function direction_n() {
    var bbox = getScreenBBox();
    return {
      top: bbox.n.y - node.offsetHeight,
      left: bbox.n.x - node.offsetWidth / 2
    };
  }
  function direction_s() {
    var bbox = getScreenBBox();
    return {
      top: bbox.s.y,
      left: bbox.s.x - node.offsetWidth / 2
    };
  }
  function direction_e() {
    var bbox = getScreenBBox();
    return {
      top: bbox.e.y - node.offsetHeight / 2,
      left: bbox.e.x
    };
  }
  function direction_w() {
    var bbox = getScreenBBox();
    return {
      top: bbox.w.y - node.offsetHeight / 2,
      left: bbox.w.x - node.offsetWidth
    };
  }
  function direction_nw() {
    var bbox = getScreenBBox();
    return {
      top: bbox.nw.y - node.offsetHeight,
      left: bbox.nw.x - node.offsetWidth
    };
  }
  function direction_ne() {
    var bbox = getScreenBBox();
    return {
      top: bbox.ne.y - node.offsetHeight,
      left: bbox.ne.x
    };
  }
  function direction_sw() {
    var bbox = getScreenBBox();
    return {
      top: bbox.sw.y,
      left: bbox.sw.x - node.offsetWidth
    };
  }
  function direction_se() {
    var bbox = getScreenBBox();
    return {
      top: bbox.se.y,
      left: bbox.se.x
    };
  }
  function getScreenBBox() {
    var targetel = target || event.target;
    while ('undefined' === typeof targetel.getScreenCTM && 'undefined' === targetel.parentNode) {
      targetel = targetel.parentNode;
    }
    var bbox = {},
      matrix = targetel.getScreenCTM(),
      tbbox = targetel.getBBox(),
      width = tbbox.width,
      height = tbbox.height,
      x = tbbox.x,
      y = tbbox.y;
    point.x = x;
    point.y = y;
    bbox.nw = point.matrixTransform(matrix);
    point.x += width;
    bbox.ne = point.matrixTransform(matrix);
    point.y += height;
    bbox.se = point.matrixTransform(matrix);
    point.x -= width;
    bbox.sw = point.matrixTransform(matrix);
    point.y -= height / 2;
    bbox.w = point.matrixTransform(matrix);
    point.x += width;
    bbox.e = point.matrixTransform(matrix);
    point.x -= width / 2;
    point.y -= height / 2;
    bbox.n = point.matrixTransform(matrix);
    point.y += height;
    bbox.s = point.matrixTransform(matrix);
    return bbox;
  }
  var direction_callbacks = {
      n: direction_n,
      s: direction_s,
      e: direction_e,
      w: direction_w,
      nw: direction_nw,
      ne: direction_ne,
      sw: direction_sw,
      se: direction_se
    },
    directions = Object.keys(direction_callbacks);
  return _impl;
}

export { version, tip as body };
